import { useEffect } from 'react';
import { connect } from 'react-redux';
import {enableSquareFootage} from "../../actions/sqftFunctions";

const SquareFootageToolPage = (props) => {
  const { enableSquareFootage } = props
  useEffect(() => {
    enableSquareFootage(true);
    return () => {
      enableSquareFootage(false);
    };
  }, [enableSquareFootage]);

  return null;
};

const mapDispatchToProps = {
  enableSquareFootage,
};

export default connect(null, mapDispatchToProps)(SquareFootageToolPage);
